module.exports = "/_next/static/images/btnTip-237553692af9138bfb4d0c25d4abca5a.png";